// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./components/HomePage";
import AboutPage from "./components/AboutPage";
import ContactPage from "./components/ContactPage";
import WebsiteDevelopmentPage from "./components/WebsiteDevelopmentPage";
import DigitalMarketingPage from "./components/DigitalMarketingPage";
import AppDevelopmentPage from "./components/AppDevelopmentPage";
import VideoDevelopmentPage from "./components/VideoDevelopmentPage";

function App() {
  return (
    <div className="font-sans text-gray-800 overflow-hidden">
      <Header />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />

        {/* ✅ Dropdown service routes */}
        <Route
          path="/services/website-development"
          element={<WebsiteDevelopmentPage />}
        />
        <Route
          path="/services/digital-marketing"
          element={<DigitalMarketingPage />}
        />
        <Route
          path="/services/app-development"
          element={<AppDevelopmentPage />}
        />
        <Route
          path="/services/video-development"
          element={<VideoDevelopmentPage />}
        />
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
